import { render, staticRenderFns } from "./VsCommentIcon.vue?vue&type=template&id=557a8d3c"
import script from "./VsCommentIcon.vue?vue&type=script&lang=js"
export * from "./VsCommentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports